import {
  ARTICLE_FEED_SECTION_ID,
  type TUseArticleFeed,
} from "@/ui/components/sections/articles/ArticleFeed/ArticleFeed.config";
import { useScroll } from "@/ui/lib/hooks/Scroll/useScroll";
import {
  useFiltersStore,
} from "libs/state/src/lib/stores/tanstack/filters/useFiltersStore";

export const useArticleFeed = (): TUseArticleFeed => {
  const { updateFilters } = useFiltersStore();
  const { scrollToId } = useScroll();

  return {
    handlePageChange: (page) => {
      updateFilters("articles:page", page);
      scrollToId(ARTICLE_FEED_SECTION_ID);
    },
  };
};
